export const testimonials = [
  {
    name: "Keerthana S.",
    text:
      "The wedding cake was absolutely beautiful and tasted amazing. Every detail was done perfectly, exactly as we requested. Many of our guests asked where we ordered it from.",
    rating: 5,
    date: "Wedding Cake • January 2025",
    accent: "bg-gradient-to-br from-pink-500 via-rose-500 to-orange-400",
    gender: "female"
  },
  {
    name: "Arun V.",
    text:
      "I have ordered several cakes from Nithuja Cakes and every time the quality has been excellent. The cakes are always fresh, soft, and well designed. Highly recommended.",
    rating: 5,
    date: "Birthday Cakes • Multiple Orders",
    accent: "bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500",
    gender: "male"
  },
  {
    name: "Pratheepa K.",
    text:
      "For my daughter’s birthday, the cake was simply perfect. The design was beautiful and the taste was loved by both kids and adults. It made the celebration very special.",
    rating: 5,
    date: "Birthday Cake • March 2024",
    accent: "bg-gradient-to-br from-amber-500 via-red-500 to-rose-500",
    gender: "female"
  }
];
